import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import { Button } from '@mui/material'

import { dateTimeTableFormat } from '@/constants/date'
import { ContributionsLibraryColumnProps } from '@/state/transactions/models'
import {
  useContributions,
  useContributionsActions,
  useContributionsFilters,
} from '@/views/contributions/hooks'

import { TableGenericComponent } from '@/views/components'
import { ContributionsTableRow } from './row.component'

export const ContributionsTableComponent = () => {
  const { t } = useTranslation()

  const {
    isLoading,
    sortedRows,
    createSortHandler,
    order,
    orderBy,
    headCells,
    getXlsFormattedRow,
    contributionsFilters,
    pagination,
  } = useContributions()

  const { getAllFreePlayContributions } = useContributionsActions()

  const { handleChangeLimit, handleChangePage } = useContributionsFilters()

  const body = sortedRows.map((row: ContributionsLibraryColumnProps) => {
    return <ContributionsTableRow key={row.id} row={row} />
  })

  const fileName = `contributions-${format(new Date(), dateTimeTableFormat)}`

  const xlsxButton = (
    <Button
      onClick={() =>
        getAllFreePlayContributions(
          {
            ...contributionsFilters,
            page: 1,
            limit: 999999,
            xlsx: true,
          },
          headCells,
          fileName,
          getXlsFormattedRow,
        )
      }
      variant="contained"
    >
      {t('labels.downloadAsXLS')}
    </Button>
  )

  return (
    <TableGenericComponent<ContributionsLibraryColumnProps>
      order={order}
      orderBy={orderBy}
      headCells={headCells}
      rowLength={sortedRows.length}
      pagination={pagination}
      isLoading={isLoading}
      body={body}
      hasAction={true}
      leftContent={xlsxButton}
      createSortHandler={createSortHandler}
      handleChangePage={handleChangePage}
      handleChangeLimit={handleChangeLimit}
    />
  )
}
